export const ENVIRONMENT_HOSTS = {
  TEST_SO_N11:
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'branch'
      ? 'https://testso.n11.com'
      : '',
};

export const HOST_NAMES = {
  'localhost': 'https://test.n11.com',
  'testso.n11.com': 'https://test.n11.com',
  'qaso.n11.com': 'https://qa.n11.com',
  'stso.n11.com': 'https://st.n11.com',
};
